export default __webpack_public_path__ + "static/media/location-arrow.32c6d2ae.svg";